import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2026/tabela-copa-amizade-de-jiu-jitsu-2026.jpeg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import shopMundoDigital from "../../assets/images/sponsors/shop-mundo-digital.jpeg";
import jblByHarmanfrom from "../../assets/images/sponsors/jbl-by-harman.jpeg";
import stormStrong from "../../assets/images/sponsors/storm-strong-fundo-branco.jpg";
import gaziny from "../../assets/images/sponsors/gazin.jpg";
import vitalle from "../../assets/images/sponsors/vitalle.jpg";
import lojaAndrea from "../../assets/images/sponsors/loja-andrea.jpeg";
import tittansMecanicaADiesel from "../../assets/images/sponsors/titans-mecanica-a-diesel.jpeg";
import texasLubrificantes5EstrelasDoBrasil from "../../assets/images/sponsors/texas-lubrificantes-5-estrelas-do-brasil.jpeg";
import mundoMedicoProdutosHospitalares from "../../assets/images/sponsors/mundo-medico-produtos-hospitalares.jpg";
import centerIvestimentos from "../../assets/images/sponsors/centerInvestimentos.png";
import postoCarretao from "../../assets/images/sponsors/postoCarretao.png";
import fenix from "../../assets/images/sponsors/fenix.jpg";
import inove from "../../assets/images/sponsors/inove.jpeg";
import realPanificadora from "../../assets/images/sponsors/real-panificadora.jpeg";
import twPaineis from "../../assets/images/sponsors/tw-paineis.jpg";
import xport from "../../assets/images/sponsors/export-nutricao.png";
import laborderm from "../../assets/images/sponsors/laborderm-farmacia.png";
import energyDrink from "../../assets/images/sponsors/energy-drink.jpeg";
import refriGold from "../../assets/images/sponsors/refrigerante-aba-gold.png";
import personaliseUniformes from "../../assets/images/sponsors/personalise-uniformes.png";




//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";

const sponsors = [
  { img: torneio, url: "http://www.torneiofacil.com" },
  { img: shopMundoDigital, url: "https://www.instagram.com/shopmundodigital?igsh=bGUyZjR2bzA0eGZr" },
  { img: jblByHarmanfrom, url: "https://www.instagram.com/jbl_brasil?igsh=MXI1bjNucHZkMHpxYg==" },
  { img: gaziny, url: "https://www.instagram.com/gazin?igsh=MXdjaGlsem8wY3NzYw==" },
  // { img: vitalle, url: "https://www.instagram.com/vitallefarmaciamanipulacao?igsh=d2RtYWpiYXoxZXlp" },
  { img: stormStrong, url: "https://www.instagram.com/stormstrongbr?igsh=MWprMGJrajVvdXhpMg==" },
  { img: lojaAndrea, url: "https://www.instagram.com/lojaandreaumuarama?igsh=YzIzbWxlbzN4MjVy" },
  { img: tittansMecanicaADiesel, url: "#" },
  { img: texasLubrificantes5EstrelasDoBrasil, url: "https://www.instagram.com/texsalubrificante?igsh=amJzeGR0NHAwNmUw" },
  { img: mundoMedicoProdutosHospitalares, url: "https://www.mundomedicoumuarama.com.br/" },
  // { img: centerIvestimentos, url: "" },
  // { img: postoCarretao, url: "" },
  { img: fenix, url: "" },
  // { img: inove, url: "" },
  { img: realPanificadora, url: "" },
  // { img: twPaineis, url: "" },
  { img: xport, url: "" },
  { img: laborderm, url: "" },
  { img: energyDrink, url: "" },
  { img: refriGold, url: "" },
  { img: personaliseUniformes, url: "" },

];


const support = [
  { img: torneio, url: "http://www.torneiofacil.com" },
   { img: trevusMartialArts, url: "https://www.instagram.com/trevusmartialarts?igsh=MXEwbWRobW52ZzQ0Zw==" },
];


const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "29 de março de 2026 "
const horaEvento = "9:30h da manhã"
const tituloEvento = "Copa Amizade de Jiu Jitsu Gi"
const localEvento = "Ginásio de Esportes Amário Vieira da Costa"
const endereçoEvento = "Av. Gov. Parigot de Souza, 4284-4454 - Zona I, Umuarama - PR,CEP 87503-680"
const dataDeEncerramentoIncricao = "25/MAR/2026"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "25/MAR/2026"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLoteUnico = "25/MAR/2026"

//Valores LOTE único até 25/03/2024
const valorinscricaoCategoriaLoteUnico = "155,00 (cento e cinquenta e cinco reais)"

const dataDeDivulgacaoChaves = "28/MAR/2026"
const horaDeDivulgacaoChaves = "23h:59min"

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const instituicaoBancaria = "SICOOB";
const tipoDeChavePix = "CELULAR";
const ChavePix = "44999991141";
const BeneficiarioDaChavePix = "Luiza Carlini Francisco";

const contatoWhatsApp1 = "+55 (44)  - Karla"
//const contatoWhatsApp2 = "+55 (43) 98443-8222 - Tony de Souza"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515 - Torneio Fácil"

const slugGI = "copa-amizade-de-jiu-jitsu-2026-umuarama-pr-gi";
const slugNOGI = "";
const rotaInscriçaoGi = `/enrollment/copa-amizade-de-jiu-jitsu-2026-umuarama-pr-gi`;
const rotaChecagemGi = "/check/copa-amizade-de-jiu-jitsu-2026-umuarama-pr-gi/search";
const rotaChecagemNogi = "";
const rotaChavesGi = "/tournament/keys/copa-amizade-de-jiu-jitsu-2026-umuarama-pr-gi"
const rotaChavesNogi = ""


const CopaAmizadeDeJiuJitsu2026: React.FC = () => {
  const { authenticated, getToken } = useAuthenticate();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToSubscriptionPage = async () => {

    if (!authenticated) {
      Swal.fire({
        title: 'Você precisa estar autenticado',
        text: 'Deseja fazer login para se inscrever no evento?',
        icon: 'info',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Fazer login',
        focusConfirm: false,
        cancelButtonText: 'Agora não'
      }).then((action) => {
        if (action.isConfirmed) navigate('/login')
      });
      return;
    }

    const response = await api.get(
      `/tournaments/info/${slugGI}`,
      {
        headers: { Authorization: `Bearer ${getToken()}` },
      }
    );

    if (response.data.canSubscribe === false) {
      Swal.fire({
        title: 'Atenção!',
        text: 'Período de inscrição encerrado!',
        icon: 'error',
      });
      toast.error('Período de inscrição encerrado!');
      return;
    }

    navigate(`/enrollment/${slugGI}`)

  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2026/copa-amizade-de-jiu-jitsu-2026.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2026/copa-amizade-de-jiu-jitsu-2026-tournament.jpeg")}
              imageMobile={require("../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2026/copa-amizade-de-jiu-jitsu-2026.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/gJPnjhrjfwBrUa468"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                    A {tituloEvento} é um evento tradicional Paranaense
                      fomentando e incentivando a prática do jiu jitsu no Paraná . As lutas
                      serão exclusivamente com GI (com kimono), o evento disponibilizará
                      categorias para todas as idades e faixas, conforme as tabelas de peso
                      deste edital. Os competidores terão a oportunidade de testar suas
                      habilidades em um ambiente controlado e com acompanhamento de
                      profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

                <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                  {/* <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> */}
                </Collapse>
                <Collapse title="PREMIAÇÕES:  DINHEIRO💰 + TROFÉU🏆 + MEDALHAS🥇" >

                  {/* <H3>Academias:</H3>
                  <P>1° lugar: 💰 Dinheiro + 🏆 Troféu </P>
                  <P>2° lugar: 💰 Dinheiro + 🏆 Troféu </P>
                  <P>3° lugar: 💰 Dinheiro + 🏆 Troféu </P> */}

                  <br />
                  <H3>Absoluto Masculino GI:</H3>
                   <H5>Juvenil todas as faixas </H5>
                  <P>1° lugar: R$200,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto e Master Branca - (juntos) </H5>
                  <P>1° lugar: R$300,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto e Master Azul - (juntos) </H5>
                  <P>1° lugar: R$400,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto e Master Roxa - (juntos) </H5>
                  <P>1° lugar: R$400,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto Marrom e Preta - (juntos) </H5>
                  <P>1° lugar: R$700,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Master 1 e 2 - Marrom e Preta - (juntos) </H5>
                  <P>1° lugar: R700,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Master 3 , 4 e 5 - Marrom e Preta - (juntos) </H5>
                  <P>1° lugar: R700,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <br />

                  <H3>Absoluto Feminino GI:</H3>
                  <H5>Juvenil/Adulto/Master Branca - (juntas) </H5>
                  <P>1° lugar: R$200,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Juvenil/Adulto/Master Azul e Roxa - (juntas) </H5>
                  <P>1° lugar: R$300,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <H5>Adulto/Master Marrom e Preta - (juntas) </H5>
                  <P>1° lugar: R$500,00 💰 + Medalha🥇</P>
                  <P>2° lugar: Medalha🥈</P>
                  <P>3° lugar: Medalha🥉</P>
                  <br />
                  <H3>Demais Categorias GI</H3>
                  <P>1° lugar: medalha🥇</P>
                  <P>2° lugar: medalha🥈</P>
                  <P>3° lugar: medalha🥉</P>
                  <br />
                 <P>Para a realização de lutas na categoria absoluta, é exigido um mínimo de 4 atletas inscritos.</P>
                 <P>A premiação nas categorias absoluto será efetuada somente se o número de participantes atingir o mínimo de 8 inscritos.</P>
                 <P>Número menor que 8 atletas a premiação ficará a criterio da organização do evento, podendo não ter premiação. </P>
                  <p>
                    Mais informações sobre as inscrições para o absoluto está disponível
                    na seção INSCRIÇÕES, parágrafo Inscrição de Absoluto deste edital.
                  </p>
                  <br />
                </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2026, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2026,
                    conforme regra da CBJJ.
                  </P>
                 
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  {/* <H3>Valor  </H3>
                  <P>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} (quarenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <br />
                  <P>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} (setenta reais)</P>

                  <br />
                  <P>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ { valorinscricaoCategoriaAbsolutoLote3} (quarenta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} (cem reais)</P>
                  <br /> */}

                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
              
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até  {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
               
                  <br />
                  <H3>Chaves</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                   As inscrições para os absolutos são gratuitas, podendo ter no máximo 3
                   atletas da mesma equipe por absoluto.
                  </P>
                   <P>
                   As inscrições para os absolutos serão realizadas pelo professor
                   responsável, ou pelo atleta, junto a organização do evento no dia do torneio
                   após a finalização das lutas da categoria.
                   </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão em lote único:
                  </Span>
                  <H3>Lote único até {dataDeEncerramentoInscricaoLoteUnico}</H3>
                  <P>Inscrição categoria GI R$ {valorinscricaoCategoriaLoteUnico} </P>
                  <P>
                     Incluso: Inscrição na Categoria de Peso + Inscrição no Absoluto (Grátis).
                  </P>
                  <br />

                </Collapse>

                <Collapse title="PAGAMENTO">
                  <H3>
                    A baixa do pagamento será efetuada de forma automática.
                  </H3>
                  <H3>
                    É necessário completar todas as etapas até finalizar a operação de pagamento.
                  </H3>
                  {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                  <p />
                  {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                </Collapse>

                <Collapse title="CATEGORIAS COM APENAS UM COMPETIDOR (SEM LUTA)">
                    <Span>
                    Caso o atleta não tenha adversário em sua categoria original após o fechamento da checagem, ele terá as seguintes opções:
                    </Span>
                    <P>
                    Permanecer sozinho na categoria, receber a Medalha (W.O.): Comparecer ao pódio e receber a medalha de ouro.
                    </P>
                    <P> O atleta poderá solicitar a mudança para a categoria de peso acima ou, se preferir, para a categoria de 
                      faixa acima, para garantir que tenha lutas.</P>
                    <P>
                    Esta solicitação deve ser feita durante o período de checagem até 25/MAR/2026 (quarta-feira) às 20:00 min.
                    </P>
                    <P>NÃO HAVERÁ LUTAS CASADAS NESSE EVENTO</P>
                  </Collapse>

                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Uma vez PAGA a inscrição, o atleta tem direito ao reembolso nas seguintes situações:
                  </H3>
                  <P>
                    1) Quando o evento é CANCELADO por parte da organização.
                  </P>
                  <P>
                    2) Quando ocorre alteração na DATA do evento.
                  </P>
                  <P>
                    3) Quando altera o LOCAL do evento com distância maior que 20km em relação ao anterior.
                  </P>
                  <P>
                    4) Quando há diminuição da premiação, somente para os atletas impactados.
                  </P>
                  <H3>
                    Obs: Para os 4 casos acima, o prazo máximo para solicitar reembolso será de até 5 dias (corridos)
                    após a divulgação do COMUNICADO no site www.torneiofacil.com.br ou DATA FIM da CHECAGEM GERAL ABERTA ( a data que ocorrer primeiro ).
                  </H3>
                  <P>
                    5) Quando o atleta se lesiona e tenha comprado a GARANTIA CAMPEÃ no ato da inscrição (desde que apresente um laudo médico
                    comprovando a lesão até SEGUNDA-FEIRA antecedente ao evento, através do Fale Conosco). Neste caso da garantia, o atleta
                    usufrui do reembolso de 80% do valor pago na inscrição.
                  </P>
                  <P>
                    Em caso de CALAMIDADE PÚBLICA, PANDEMIA, CATÁSTROFE NATURAL e DECRETOS GOVERNAMENTAIS, considerados motivo de FORÇA MAIOR,
                    o atleta NÃO TEM direito ao reembolso.
                  </P>
                  <P>
                    Para estes casos, a organização oferecerá alternativas para uso do crédito do atleta que não puder comparecer na nova data
                    do evento, ao invés do reembolso, desde que o atleta nos notifique pelo FALE CONOSCO até SEGUNDA-FEIRA antecedente ao evento).
                  </P>
                  <P>
                    Após os períodos predeterminados, o atleta perderá o direito a reembolso ou crédito.
                  </P>
                  <H3>
                    Além disso, o atleta NÃO tem direito a reembolso de valores quando:
                  </H3>
                  <P>
                    1) Está sozinho na chave de luta.
                  </P>
                  <P>
                    2) Se machuca antes do evento impossibilitando o atleta de participar do mesmo, sem ter adquirido a GARANTIA CAMPEÃ.
                  </P>
                  <P>
                    3) Desistência por qualquer motivo.
                  </P>
                  {/* <H3>
                      Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                      inscrição, sendo obrigatório a comprovação e apresentação de atestado
                      médico.
                    </H3>
                    <H3>
                      Após o fim do período de inscrição não será possível o reembolso das
                      inscrições pagas.
                    </H3> */}
                </Collapse>

                <Collapse title="REGRAS">

                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  <Span>
                   Haverá premiação em dinheiro para o primeiro lugar , somente na
                   categoria absoluto.
                  </Span>
                  <Span>
                   O atleta que perdeu a semifinal para o Campeão ficará em terceiro
                   lugar e o atleta que perdeu a semifinal para o Vice-Campeão ficará em
                   quarto lugar.
                  </Span>
                  <Span>
                  Para categoria com 3 lutadores, aplica-se a regra melhor de 3.
                  Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span>
                  {/* <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span> */}
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do inicio da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                  <Span>
                    Afim de evitar chaves sem lutas o esquema de faixa usado
                    será o seguinte:
                  </Span>
                  <P> Branca </P>
                  <P> Cinza e Amarela (Juntas) </P>
                  <P> Laranja e Verde (Juntas)</P>
                  <P> Azul; </P>
                  <P> Roxa; </P>
                  <P> Marrom; </P>
                  <P> Preta. </P>
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>
                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  {/* <Span>Teremos 4 (quatro) aréas de lutas</Span> */}
                  {/*  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />

                  {/* <Span><b>TEMPO DE LUTA</b></Span>

                    <P>Pré-mirim: 2 min (Todas as faixas)</P>               
                    <P>Mirim A: 3 min (Todas as faixas)</P>
                    <P>Mirim B: 3 min (Todas as faixas)</P>
                    <P>Infantil A: 4 min (Todas as faixas)</P>
                    <P>Infantil B: 4 min (Todas as faixas)</P>
                    <P>Infanto Juvenil: 4 min (Todas as faixas)</P>
                    <P>Juvenil: 5 min (Todas as faixas)</P>
                    <P>Adulto: 5 min (Todas as faixas)</P>
                    <P>Master 1 e 2: 5 min (Todas as faixas)</P>
                    <P>Master 3, 4 e 5: 5 min (Todas as faixas)</P>

                  <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>
                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistência do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com atletas somente da mesma academia não contam pontos
                    para a disputa por academias, para contar pontos é necessário ao menos um
                    atleta de outra academia para validar a chave.
                  </P> */}
                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P>
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
              
         
                  <Container>
                      <h5>COPA AMIZADE DE JIU JITSU 2026</h5>

                      <h5>09:00 - Categorias Pré-Mirim e Mirim A - Todas as Faixas Masculino/Feminino na área de aquecimento.</h5>
                      <h5>09:15 - Abertura Oficial</h5>
                      <h5>09:30 - Início do evento</h5>
                      <h5>09:50 - Categorias Mirim B - Todas as Faixas Masculino/Feminino.</h5>
                      <h5>10:20 - Categorias Infantil A - Todas as Faixas Masculino/Feminino.</h5>
                      <h5>10:50 - Categorias Infantil B - Todas as Faixas Masculino/Feminino.</h5>
                      <h5>11:20 - Infanto-Juvenil Todas as Faixas Masculino/Feminino.</h5>
                      <h5>11:50 - Juvenil Todas as Faixas Masculino/Feminino.</h5>
                      <h5>12:20 - Faixa Branca Masculino e Feminino Adulto e Master</h5>
                      <h5>13:30 - Faixa Azul Masculino e Feminino Adulto e Master</h5>
                      <h5>14:00 - Faixa Roxa Masculino e Feminino Adulto e Master</h5>
                      <h5>14:30 - Faixas Marrom e Preta Adulto e Master</h5>
                      <h5>14:50 - Início das Inscrições para os Absolutos Masculino/Feminino</h5>
                      <h5>15:20 - Início dos Absolutos Masculino/Feminino</h5>
                      <h5>Juvenil - Todas as Faixas</h5>
                      <h5>Adulto e Master Branca</h5>
                      <h5>Adulto e Master Azul</h5>
                      <h5>Adulto e Master Roxa</h5>
                      <h5>Adulto e Master Marrom/Preta</h5>

                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li>
                      <li>O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a necessidade do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li>
                      <li>Pedimos que os atletas estejam de quimono 30 minutos antes do horário da sua categoria no cronograma.</li>
                      <li>Será verificada a condição do quimono.</li>
                      <li>Só é permitido lutar com quimono nas cores branco, azul e preto. Exceção: quimono rosa para meninas.</li>
                      <li>As inscrições do Absoluto acontecerão somente no dia do evento.</li>
                      <li>Só haverá Absoluto se houver, no mínimo, 04 atletas inscritos, podendo haver redução na premiação.</li>
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <p>Que Deus nos abençoe 🙏🏼...</p>
                    <br />Ossssssssss 
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                  <P>
                    Liberada ao público.
                  </P>
                  {/* <br />
                <P>Crianças até 5 anos ficam isentas de qualquer tipo de pagamento.</P>
                <br /> */}
                </Collapse>
                <Collapse title="CONTATO">
                  <P>Dúvidas sobre o evento, cronograma ou edital, entre em contato por telefone ou WhatsApp.</P>
                  <a target={"blank"} href="https://whatsa.me/5544997269732/?t=Ol%C3%A1,%20Karla!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*COPA%20AMIZADE%20DE%20JIU%20JITSU%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp1} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  {/* <a target={"blank"} href="https://whatsa.me/5543984438222/?t=Ol%C3%A1,%20Tony%20de%20Souza!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*COPA%20ARAPONGAS%20DE%20JIU%20JITSU%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp2} </strong>
                    <FaWhatsapp />
                  </a>
                  <br /> */}
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20na%20*COPA%20AMIZADE%20DE%20JIU%20JITSU%202026*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage()}>
                {/* <TournamentEnrollmentLinkEndpage to="#"> */}
                Inscrição
              </TournamentEnrollmentLinkEndpage>

              <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                Correção da Inscrição
              </TournamentEnrollmentLinkEndpage>
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>
            {/*   <TournamentLink
                // target="_blank"
                href={rotaChecagemNogi}
              >
                Checagem NOGI
              </TournamentLink>
 */}
              {/* <TournamentLink
                // target="_blank"
                href={rotaChecagemNoGi}
              >
                Checagem NOGI
              </TournamentLink> */}

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGi}
              >
                Chaves GI
              </TournamentLink>
      {/*         <TournamentLink
                // target="_blank"
                href={rotaChavesNogi}
              >
                Chaves NOGI
              </TournamentLink> */}


              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default CopaAmizadeDeJiuJitsu2026;
